import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore, useUser } from "../../../Utils/utils";
import { blog_page_labels } from "../../../Constants/Labels";
import { select_store_message } from "../../../Constants/Messages";
import "./BlogList.css";

export default function BlogList({ searchResult, loader }) {
  const navigate = useNavigate();
  const { store } = useStore();
  const storeId = store?.id;
  const [blogOrder, setBlogOrder] = useState([]);

  useEffect(() => {
    if (searchResult && searchResult.length > 0) {
      setBlogOrder(searchResult);
    } else {
        setBlogOrder([]);
    }
  }, [searchResult]);

  const editBlog = (id) => {
      navigate(`/admin/blog/edit/${id}`);
  };

  return (
    <>
      <div className={loader ? "loderHide" : "loderShow"}>
        {!storeId || storeId === "Admin" ? (
          <p className="text-center">{select_store_message?.select_store}</p>
        ) : (
          <div>
            {!searchResult || searchResult.length === 0 ? (
              <div className="card">
                <div className="card-body defaultText">
                  <p className="text-center">No blogs found.</p>
                </div>
              </div>
            ) : (
              <div className="tableOutline">
                <table className="table">
                  <thead>
                    <tr>
                       <th className="col-lg-2">
                        {
                          blog_page_labels?.blog_page_table_head_labels
                            ?.blog_id
                        }
                      </th>
                      <th className="col-lg-7">
                        {
                          blog_page_labels?.blog_page_table_head_labels
                            ?.title
                        }
                      </th>
                     
                      <th className="col-lg-2">
                        {
                          blog_page_labels?.blog_page_table_head_labels
                            ?.status
                        }
                      </th>

                      <th className="col-lg-1">
                        {
                          blog_page_labels?.blog_page_table_head_labels
                            ?.action
                        }
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {blogOrder?.map((blog) => {
                      const status =
                        blog.status === "active" ? "Active" : "Inactive";
                      return (
                        <tr
                          key={blog.blog_post_id || blog.id}
                        >
                          <td
                            onClick={() => editBlog(blog.blog_id)}
                            className=""
                          >
                            {blog.blog_id}
                          </td>
                          <td>{blog.title}</td>
                          <td>{status}</td>
                            <td>
                              <span
                                className="mdi mdi-account-edit icon"
                                onClick={() =>
                                  editBlog(blog.blog_id)
                                }
                              ></span>
                            </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
